export const DECRYPT_ERROR = 'DECRYPT_ERROR'

export const WALLETCONNECT = 'walletconnect'

export const DONT_SHOW_TUTORIAL_AGAIN_KEY_LEDGER = 'RLogin:DontShowTutorialAgain:Ledger'
export const DONT_SHOW_TUTORIAL_AGAIN_KEY_TREZOR = 'RLogin:DontShowTutorialAgain:Trezor'
export const DONT_SHOW_TUTORIAL_AGAIN_KEY_DCENT = 'RLogin:DontShowTutorialAgain:DCent'

export const RLOGIN_SELECTED_PROVIDER = 'RLOGIN_SELECTED_PROVIDER'
export const CACHED_PROVIDER_KEY = 'RLOGIN_CACHED_PROVIDER'
export const DONT_SHOW_AGAIN_KEY = 'RLogin:DontShowAgain'
